import { Component, ViewChild } from "@angular/core";
import { ComponentPageBase } from "../../../shared/components/component-page-base/component-page-base";
import { LaboratoryExaminationMethodDto } from "../../../shared/models/laboratory/laboratory-examination-method.dto";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "../../../app.service";
import { NotificationService } from "../../../core/services/notification.service";
import { LaboratoryExaminationMethodsService } from "../laboratory-examination-methods.service";
import { UserGroupsEnum } from "../../../shared/enums/user-groups-enum";
import { UserGroupsService } from "../../../shared/services/user-groups.service";
import { forkJoin } from "rxjs";
import { KeyValueObject } from "../../../shared/models/core/KeyValueObject";
import { LaboratoriesService } from "../../../shared/services/laboratories.service";
import { EntityViewModel } from "../../../shared/models/core/EntityViewModel";
import { LaboratoryIndicatorExaminationMethodDto } from "../../../shared/models/laboratory/laboratory-indicator-examination-method.dto";
import { GridComponent } from "@progress/kendo-angular-grid";
import { Guid } from "guid-typescript";

@Component({
    selector: 'laboratory-examination-method',
    templateUrl: './object.page.html',
    styleUrls: [
        './object.page.scss',
        '../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
        '../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss'
    ]
})
export class LaboratoryExaminationMethodPage extends ComponentPageBase<LaboratoryExaminationMethodDto> {

    @ViewChild("indicatorMethodsGrid") indicatorMethodsGrid: GridComponent;

    laboratoryUsers: KeyValueObject[] = [];
    indicators: KeyValueObject[] = [];
    equipments: KeyValueObject[] = [];
    loaded: boolean = false;

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected appService: AppService,
        protected notificationService: NotificationService,
        protected dataService: LaboratoryExaminationMethodsService,
        protected userGroupsService: UserGroupsService,
        protected laboratoriesService: LaboratoriesService
    ) {
        super(route, router, appService, notificationService, dataService);
        this.listPageRoutePath = 'categories/laboratory-examination-methods';
        this.appService.pageTitle = 'Новый метод испытаний';
    }

	ngOnInit() {	
		this.entityId = this.route.snapshot.paramMap.get('laboratoryExaminationMethodId');

		if (this.entityId != null) {
            this.dataService.getById(+this.entityId).subscribe(vm => {
				this.entityName = vm.entity.name;
				this.dataBind(vm);
                this.initData();
            });
		} else {
            this.entityViewModel = new EntityViewModel;
            this.entityViewModel.entity = new LaboratoryExaminationMethodDto();
            this.canEditForm = true;
            this.isNew = true;

            this.initData();
		}
	}

    initData() {
        this.entityViewModel.entity.indicatorExaminationMethods.forEach(x => x.uuid = Guid.create().toString());

        const laboratoryUsers$ = this.userGroupsService.getUsersByGroup(<number>UserGroupsEnum.laboratoryEmployees);
        const indicators$ = this.laboratoriesService.getAllIndicators();
        const equipments$ = this.laboratoriesService.getAllExaminationEquipments();

        forkJoin([laboratoryUsers$, indicators$, equipments$])
        .subscribe(([laboratoryUsers, indicators, equipments]) => {
            this.laboratoryUsers = laboratoryUsers;
            this.indicators = indicators.data.map(x => new KeyValueObject(x.laboratoryIndicatorId, x.name));
            this.equipments = equipments.data.map(x => new KeyValueObject(x.laboratoryExaminationEquipmentId, x.name));

            this.loaded = true;
        }); 
    }

    cancelEdit() {
        this.entityViewModel.entity.indicatorExaminationMethods.forEach((x, i) => {
            this.indicatorMethodsGrid.closeRow(i);
        })

        super.cancelEdit();
    }

    turnExaminationMethodIsDefault(event: any, dataItem: LaboratoryIndicatorExaminationMethodDto) {
        if (event.target.checked) {
            this.entityViewModel.entity.indicatorExaminationMethods.forEach(x => x.isDefault = x.uuid == dataItem.uuid);   
        }
    }

    createNewIndicatorMethod(): LaboratoryIndicatorExaminationMethodDto {
        return new LaboratoryIndicatorExaminationMethodDto();
    }

    addNewIndicator() {
        this.indicatorMethodsGrid.addRow(this.createNewIndicatorMethod());
    }

    getDoubleAccuracy(item: LaboratoryIndicatorExaminationMethodDto) {
        return item.accuracy != null && item.accuracy > 0
            ? '0.' + '0'.repeat(item.accuracy - 1) + '1'
            : '0';
    }

    getNameById(id: number, values: KeyValueObject[] = []): string {
        var value = values.find(x => x.id == id);

        return value != null ? value.name : '';
    }

    canSaveIndicatorExaminationMethod(item: LaboratoryIndicatorExaminationMethodDto) {
        return item.laboratoryExaminationEquipmentId != null &&
               item.laboratoryIndicatorId != null &&
               item.accuracy >= 0;
    }

    lessThenZero(value: number) {
        return value < 0;
    }
}